import { ServiceType } from '../types';

export const getUniqueCategories = (
  services: ServiceType[],
  isInfoComponent = false
): string[] => {
  const categories = isInfoComponent
    ? ['All Services', ...services.map((item) => item.category)]
    : services.map((item) => item.category);

  return categories.filter(function (item, pos) {
    return categories.indexOf(item) == pos;
  });
};
